import api from 'services/api'
import { BACKEND_URL } from 'configs'

const baseUrl = `${BACKEND_URL}/microsoft/auth/v2`

const getIdPRedirectUrl = () => {
  return api.get(`${baseUrl}/signin`)
}

const singInUserByToken = (idToken: string) => {
  const headers = new Headers()
  headers.append('Content-Type', 'application/x-www-form-urlencoded')
  return fetch(BACKEND_URL + '/sso/login', {
    method: 'POST',
    credentials: 'include',
    body: new URLSearchParams({ idToken }),
    headers: headers,
  })
}

const exchangeCodeForToken = (code: string) => {
  return api.post(`${baseUrl}/code`, { code })
}

export const microsoftAuthService = {
  getIdPRedirectUrl,
  singInUserByToken,
  exchangeCodeForToken,
}
